function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 48,
  height: 48,
  rx: 24,
  fill: "#C7CBDD"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_4919_767)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25 34.906C27.5127 32.7786 30.5894 31.4272 33.856 31.016C34.2409 30.9653 34.5943 30.7763 34.8502 30.4843C35.1062 30.1923 35.2472 29.8173 35.247 29.429V18.21C35.2477 17.9791 35.1987 17.7508 35.1034 17.5405C35.0081 17.3302 34.8688 17.1428 34.6947 16.9911C34.5207 16.8394 34.3161 16.7268 34.0948 16.6611C33.8735 16.5953 33.6406 16.5779 33.412 16.61C30.3089 17.0892 27.3981 18.4152 25 20.442C24.7131 20.6647 24.3602 20.7855 23.997 20.7855C23.6338 20.7855 23.2809 20.6647 22.994 20.442C20.5964 18.4168 17.6867 17.0919 14.585 16.613C14.3566 16.5809 14.124 16.5983 13.9029 16.6638C13.6818 16.7294 13.4774 16.8417 13.3034 16.9931C13.1294 17.1445 12.99 17.3315 12.8945 17.5414C12.799 17.7514 12.7498 17.9794 12.75 18.21V29.429C12.7498 29.8173 12.8908 30.1923 13.1468 30.4843C13.4027 30.7763 13.7561 30.9653 14.141 31.016C17.4086 31.4266 20.4865 32.7781 23 34.906C23.2862 35.1277 23.638 35.248 24 35.248C24.362 35.248 24.7138 35.1277 25 34.906V34.906Z",
  stroke: "#52545E",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.02 12.75C29.4418 13.3955 27.0423 14.6141 25 16.315C24.7131 16.5377 24.3602 16.6585 23.997 16.6585C23.6338 16.6585 23.2809 16.5377 22.994 16.315C20.9548 14.6155 18.5587 13.3973 15.984 12.751",
  stroke: "#52545E",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24 20.784V35.247",
  stroke: "#52545E",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_4919_767"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white",
  transform: "translate(12 12)"
})));

function SvgDictionaryIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDictionaryIcon);
export default __webpack_public_path__ + "static/media/dictionary-icon.7f3b3465.svg";
export { ForwardRef as ReactComponent };